/**
 * AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPage
 *
 * Page component for AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPage
 * Path: /blog/why-we-started-almadar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhyWeStartedAlmadarENPostPageView as __AlmadarPostWhyWeStartedAlmadarENPostPageView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarENPostPageView';
import { AlmadarPostWhyWeStartedAlmadarENPostAnalyticsView as __AlmadarPostWhyWeStartedAlmadarENPostAnalyticsView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPage(_props: AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhyWeStartedAlmadarENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhyWeStartedAlmadarENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhyWeStartedAlmadarENAlmadarPostWhyWeStartedAlmadarENPage;
